import React, { useMemo } from 'react';
import { DBO_V } from '@op/utils/format';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import TableMiniChart from '@opm/components/TableMiniChart';
import { formatSameDayFunc } from '@op/utils/time';
import PercentageItem from '@op/components/Snippets/PercentageItem';

interface IMemeMetricsCellProps {
  record: any;
  tabKey: 'views' | 'likes';
  filter: any;
  intl: (id: string) => string;
  hideChart?: boolean;
}

function MemeMetricsCell({
  record,
  tabKey,
  filter,
  intl,
  hideChart = false,
}: IMemeMetricsCellProps) {
  const { value, oldValue, ratio, timeline, data, oldTime, newTime } = useMemo(() => {
    const { video_stats: stats } = record || {};
    const value =
      stats?.total ??
      (tabKey === 'views' ? record.total_views : record.total_likes);
    const oldValue = stats?.old_total;
    const ratio = DBO_V.qoq(value, oldValue);
    const timeline = stats?.timeline || [];
    const { timeline_of_time, old_timeline_of_time } = stats || {};

    return {
      value,
      oldValue,
      ratio,
      timeline,
      data: {
        timeline,
        timeline_of_start_time:
          timeline_of_time?.timeline_of_start_time || timeline?.[0]?.time,
        timeline_of_end_time:
          timeline_of_time?.timeline_of_end_time ||
          timeline?.[timeline?.length - 1]?.time,
      },
      oldTime: [
        old_timeline_of_time?.timeline_of_start_time,
        old_timeline_of_time?.timeline_of_end_time,
      ],
      newTime: [
        timeline_of_time?.timeline_of_start_time,
        timeline_of_time?.timeline_of_end_time,
      ],
    };
  }, [record, tabKey]);

  return (
    <div className="dbom-meme-metrics">
      {/* 数值 + 环比 */}
      <div className="dbom-meme-metrics-value">
        <span className="dbom-meme-metrics-num">{DBO_V.reviews(value)}</span>
        <RingRatioBubble
          oldTime={oldTime}
          newTime={newTime}
          oldValue={oldValue}
          newValue={value}
          formateValue={DBO_V.reviews}
          formateDate={formatSameDayFunc(filter)}
          placement="top"
        >
          <PercentageItem percentage={ratio || 0} />
        </RingRatioBubble>
      </div>
      {/* 趋势图 - 单天时不显示, hideChart 时隐藏（宽屏拆列） */}
      {!hideChart && timeline && timeline.length > 1 && (
        <div className="dbom-meme-metrics-chart">
          <TableMiniChart
            name={tabKey === 'views' ? intl('Views') : intl('Likes')}
            className="dbom-meme-minichart"
            data={data}
            valueFormat={(val) => DBO_V.reviews(val)}
            height={45}
            filterEmptyValue={false}
            timeFormat='daily'
          />
        </div>
      )}
    </div>
  );
}

export default React.memo(MemeMetricsCell);